<template>
  <div
    class="infoWrapper"
    :class="fileUploadingNum ? 'uploading' : ''"
  >
    <Loading
      :contentSize="true"
      :state="loading"
    >

      <div class="wrapper">
        <h1>{{ $t( "title" ) }}</h1>

        <Autocompleter
          :class="endpoints ? '' : 'disabled'"
          class="ac"
          v-model="endpoint"
          :getItems="endpointsAC"
          style="width: 10em; margin-bottom: 2em;"
        />

        <Tabs
          class="tabs"
          :activeId="tabCurrent"
          :scrollContent="false"

          @active="tabCurrent = $event.data ? $event.data.id : null"
        >
          <Tab
            id="docSend"

            class="tab"

            :name="$t( 'DocSendTab' )"
            icon="object"

            @active=""
          >
            <div class="send">
              <Checkbox
                :label="$t( 'WholeFileProcessing' )"
                v-model="wholeFileProcessing"
                class="wholeFileProcessing"
              />

              <File
                :value="file"
                :multiple="true"
                @input="fileSelected( $event.el, $event.fn )"
              />
              <Button
                :class="file && endpoint.id ? '' : 'disabled'"
                :disabled="!file"
                @click="send()"
              >
                {{ $t( "SendFile" ) }}
              </Button>
            </div>

            <template
              v-for="data in filesDatas"
            >
              <table
                v-if="data && data.status == true"
                border="0"
                cellpadding="0"
                cellspacing="0"
                class="results"
              >
                <thead>
                  <tr><td colspan="2">обработка файла "<span>{{ data.file }}</span>"</td></tr>
                </thead>
                <tbody>
                  <tr>
                    <th>определений найдено:</th>
                    <td>{{ data.definitions ? data.definitions : "-" }}</td>
                  </tr>
                  <tr>
                    <th>сравнений построено:</th>
                    <td>{{ data.comparisons ? data.comparisons : "-" }}</td>
                  </tr>
                  <tr v-if="data.message">
                    <th colspan="2">ошибки/предупреждения обработки</th>
                  </tr>
                  <tr v-if="data.message">
                    <td colspan="2">
                      <pre>{{ data.message }}</pre>
                    </td>
                  </tr>
                </tbody>
              </table>

              <table
                v-if="data && data.status === false"
                border="0"
                cellpadding="0"
                cellspacing="0"
                class="results"
              >
                <thead>
                  <tr><td>обработка файла "<span>{{ data.file }}</span>" завершена с ошибкой</td></tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <pre>{{ data.message ? data.message : "неизвестная ошибка" }}</pre>
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
          </Tab>

          <Tab
            id="report"

            class="tab"

            :name="$t( 'DocReportTab' )"
            icon="reference"

            @active=""
          >
            <div class="report">
              <Radio
                :values="[ { label: $t( 'LexicalMatch' ), value: 'Lexical' }, { label: $t( 'SemanticMatch' ), value: 'Semantic' } ]"
                v-model="match"
              />
              <div
                class="fieldInput fieldN"
              >
                <input
                  type="text"

                  :placeholder="$t( 'n' )"

                  v-model="n"
                />
              </div>

              <Button
                :class="/^\d+(?:\.\d+)?$/.test( n ) && endpoint.id ? '' : 'disabled'"
                @click="reportGet()"
              >
                {{ $t( "ReportGet" ) }}
              </Button>

              <template v-if="report && report.status == true">
                <div class="scroller">
                  <table
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    class="results"
                    ref="reportResults"
                  >
                    <thead>
                      <tr>
                        <th>Документ</th>
                        <th
                          v-for="d in report.docs"
                        >{{ d in report.docsNames ? report.docsNames[ d ] : d }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>Число определений</th>
                        <td
                          v-for="d in report.docs"
                        >{{ d in report.defsAmount ? report.defsAmount[ d ] : "" }}</td>
                      </tr>
                      <tr
                        v-for="( r, d ) in report.matrix"
                      >
                        <th>{{ d in report.docsNames ? report.docsNames[ d ] : d }}</th>
                        <td
                          v-for="c in r"
                        >
                          {{ c }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <Button
                  :class="/^\d+(?:\.\d+)?$/.test( n ) && endpoint.id ? '' : 'disabled'"
                  @click="tableToExcel( $refs.reportResults, 'report.xls' )"
                  style="margin-top: 1em"
                >
                  {{ $t( "ExportXLS" ) }}
                </Button>
              </template>

              <table
                v-if="report && report.status === false"
                border="0"
                cellpadding="0"
                cellspacing="0"
                class="results"
              >
                <thead>
                  <tr><td>отчет завершен с ошибкой</td></tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <pre>{{ report.message ? report.message : "неизвестная ошибка" }}</pre>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Tab>
        </Tabs>
      </div>
    </Loading>

    <div class="info">
      файлов загружено: {{ fileUploadingNum }} из {{ files.length }}
      <div class="progress"><div class="filler" :style="{ width: ( 100 * fileUploadingNum / files.length ) + '%' }"></div></div>
    </div>
  </div>
</template>

<script>

import dates from "@/dates"
import utils from "@/utils"
import config from "@/config"
import api from "@/api"
import ls from "@/ls"

import Icon from "@/components/Icon";
import Button from "@/components/Button";
import Loading from "@/components/Loading";
import Modal from "../components/Modal";
import Autocompleter from "../components/Autocompleter";
import File from "../components/File";
import Tabs from "@/components/Tabs/Tabs";
import Tab from "@/components/Tabs/Tab";
import Radio from "@/components/Radio";
import Checkbox from "../components/Checkbox";

export default {
  name: "KazNIISA",

  components: {
    Icon,
    Loading,
    Modal,
    Button,
    Autocompleter,
    File,
    Tabs,
    Tab,
    Radio,
    Checkbox
  },

  i18n: {
    messages: {
      ru: {
        title: "Анализ документов",
        SendFile: "Отправить файл",
        DocSendTab: "Отправка документа на анализ",
        DocReportTab: "Отчет по документам",
        LexicalMatch: "Лексическое соответствие",
        SemanticMatch: "Семантическое соответствие",
        n: "Значение метрики",
        ReportGet: "Вывести отчет",
        WholeFileProcessing: "Обрабатывать весь файл"
      },

      en: {
        title: "Загрузка документов для анализа",
        SendFile: "Отправить файл",
        DocSendTab: "Отправка докумета",
        DocReportTab: "Отчет по документам",
        LexicalMatch: "Лексическое соответствие",
        SemanticMatch: "Семантическое соответствие",
        WholeFileProcessing: "Обрабатывать весь файл"
      },

      kz: {
        title: "Загрузка документов для анализа",
        SendFile: "Отправить файл",
        DocSendTab: "Отправка докумета",
        DocReportTab: "Отчет по документам",
        LexicalMatch: "Лексическое соответствие",
        SemanticMatch: "Семантическое соответствие",
        WholeFileProcessing: "Обрабатывать весь файл"
      }
    }
  },

  utils,

  crossHighlighter: null,

  url:      null,
  reportUrl:null,

  data() {
    return {
      loading: false,

      tabCurrent: "docSend",

      file: null, //only used to reset files in file control
      
      files: [],
      filesFn: null,
      filesDatas: [],
      fileUploadingNum: 0, //affected while from 1

      endpoints: null,
      endpoint: { id: null, name: null },

      match: "Lexical",
      n: 0.7,

      wholeFileProcessing: false,
      
      report: null
    };
  },

  mounted() {
    this.endpointsGet();
    this.configGet();
  },

  beforeUnmout() {
    if ( this.$refs.reportResults ) {
      const table = this.$refs.reportResults;
      if ( this.$options.crossHighlighter ) table.removeEventListener( "mouseout", this.$options.crossHighlighter );
      delete this.$options.crossHighlighter;
    }

  },

  methods: {
    endpointsAC() {
      const items = [];
      for ( const id in this.endpoints ) {
        if ( this.endpoints.hasOwnProperty( id ) ) items.push( { id, name: this.endpoints[ id ] } );
      }

      return items;
    },

    async configGet() {
      try {
        const ans = await api.post.json(
          "/KAZNIISA/config",
          {}
        );

        if ( !ans ) throw new Error( "malformed server answer" );
        if ( ans.error ) throw new Error( ans.error );
        if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );

        this.$options.url = ans.url ? ans.url : config.KazNIISA.url;
        this.$options.reportUrl = ans.reportUrl ? ans.reportUrl : config.KazNIISA.reportUrl;
      }
      catch ( e ) {
        console.error( "ENDPOINTS REQUEST ERROR: request items is failed with " + e.message, e.stack );
        this.$root.$emit( "notify", { header: this.$t( 'EndpointsRequestErr' ), message: e.message, type: "error" } );
      }
    },

    async endpointsGet() {
      let endpoints = {};

      try {
        const ans = await api.post.json(
          "/endpoints",
            {
              clientId: this.clientId
            }
        );

        if ( !ans ) throw new Error( "malformed server answer" );
        if ( ans.error ) throw new Error( ans.error );
        if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );
        if ( !( "items" in ans ) ) throw new Error( this.$t( "InvalidServerAnswer" ) + ": " + JSON.encode( ans ) );

        endpoints = ans.items;
      }
      catch ( e ) {
        console.error( "ENDPOINTS REQUEST ERROR: request items is failed with " + e.message, e.stack );
        this.$root.$emit( "notify", { header: this.$t( 'EndpointsRequestErr' ), message: e.message, type: "error" } );
      }

      this.endpoints = endpoints;
      if ( !this.endpoint.id ) {
        const eid = utils.objGetFirstKey( this.endpoints );
        this.endpoint = { id: eid, name: this.endpoints[ eid ] };
      }
    },

    fileSelected( el, fn ) {
      this.file = el.files[0];
      this.files = el.files;
      this.filesFn = fn;
    },

    async send() {
     this.loading = true;

      this.filesDatas = [];

      for ( let f = 0; f < this.files.length; f++ ) {
        const data = {
          file:       this.files[ f ].name,
          status:     null,
          message:    null,
          definitions:null,
          comparisons:null
        };

        try {
          let ans = null;

          try {
            ans = await this.rq(
              "",
              undefined,
              this.files[ f ],
              {
                user:     this.$store.getters["user/getEmail"](),
                endpoint: this.endpoint.id,
                force_parsing_all_file: this.wholeFileProcessing|0
              }
            );
          }
          catch ( e ) {
            ans = null;

            //on 504 retry
            if ( e.rStatus == 504 ) {
              this.$root.$emit( "notify", { message: "NLU service is busy now, retry in 1 minute...", type: "info" } );
              await utils.delay( 1000 * 60 );
              f--;
              continue;
            }

            if ( e.message === "status" && e.rData ) {
              try { ans = JSON.parse( e.rData ); } catch ( e ) {}
            }
  
            if ( !ans ) throw e;
          }

          if ( ans ) {
            this.fileUploadingNum = f + 1;

            data.message = ans.Message;
  
            if ( ans.Status == "success" ) {
              data.status = true;
              data.definitions = ans.Definitions;
              data.comparisons = ans.Comparisons;
            }
            else data.status = false;
  
            this.filesDatas.push( data );
          }
          else throw new Error( "empty answer" );
        }
        catch ( e ) {
          console.error( e );
  
          this.$root.$emit( "notify", { header: this.$t( "InvalidServerAnswer" ), message: e.message, type: "error" } );
        }
      }

      if ( this.filesDatas.length == this.files.length && this.filesDatas.find( i => !i.status ) === undefined ) {
        this.file = null;
        this.files = [];
        this.filesFn = null;
      }
      
      this.fileUploadingNum = 0;
      this.loading = false;
    },

    async rq( path, params, file, paramsGet ) {
      const postData = new FormData();
      let url = this.$options.url + path;

      if ( file ) postData.append( "file", file );

      if ( params ) {
        for ( let pName in params ) {
          if ( params.hasOwnProperty( pName ) ) {
            const pVal = params[ pName ];
            postData.append( pName, pVal );
          }
        }
      }

      if ( paramsGet ) {
        let s = "";
        for ( let pName in paramsGet ) {
          if ( paramsGet.hasOwnProperty( pName ) ) {
            const pVal = paramsGet[ pName ];
            s += "&" + pName + "=" + encodeURIComponent( pVal );
          }
        }

        url += "?" + s.substr( 1 );
      }

      let ans = null;
      let ansT = null;
      let res = null;

      res = await fetch(
        url,
        {
          method:	"POST",
          headers: {
          },
          credentials: "omit",
          body:	postData
        }
      );

      if ( res.status >= 200 && res.status <= 299 ) {
        ansT = await res.text();
        ans = JSON.parse( ansT );

        return ans;
      }

      const e = new Error( "status" );
      e.rStatus = res.status;
      e.rData = await res.text();

      console.error( "Request to \"" + url + "\" is failed with status: " + e.rStatus + ", data: " + e.rData );

      throw e;
    },

    async rqReport( paramsGet ) {
      let url = this.$options.reportUrl;

      if ( paramsGet ) {
        let s = "";
        for ( let pName in paramsGet ) {
          if ( paramsGet.hasOwnProperty( pName ) ) {
            const pVal = paramsGet[ pName ];
            s += "&" + pName + "=" + encodeURIComponent( pVal );
          }
        }

        url += "?" + s.substr( 1 );
      }

      let ans = null;
      let ansT = null;
      let res = null;

      res = await fetch(
        url,
        {
          method:	"POST",
          headers: {
          },
          credentials: "omit",
          body:	null
        }
      );

      if ( res.status >= 200 && res.status <= 299 ) {
        ansT = await res.text();
        ans = JSON.parse( ansT );

        return ans;
      }

      const e = new Error( "status" );
      e.rStatus = res.status;
      e.rData = await res.text();

      console.error( "Request to \"" + url + "\" is failed with status: " + e.rStatus + ", data: " + e.rData );

      throw e;
    },

    async reportGet() {
      this.loading = true;

      try {
        const report = {
          status: null,
          message: null
        };
        
        let ans = null;

        try {
          ans = await this.rqReport(
            {
              user: this.$store.getters["user/getEmail"](),
              endpoint: this.endpoint.id,
              use_score: this.match,
              N: this.n
            }
          );
        }
        catch ( e ) {
          ans = null;

          if ( e.message === "status" && e.rData ) {
            try { ans = JSON.parse( e.rData ); } catch ( e ) {}
          }

          if ( !ans ) throw e;
        }

        if ( ans ) {
          report.message = ans.Message;

          if ( ans.Status == "success" ) {
            report.status = true;
            report.defsAmount = ans.amount_definitions;
            const commons = ans.matrix_common;
            const comparisons = ans.matrix_comparisons;

            const docs = new Set();
            Object.keys( ans.amount_definitions ).forEach( i => docs.add( i ) );
            Object.entries( commons ).forEach(
                i => {
                  docs.add( i[0] );
                  Object.keys( i[1] ).forEach( j => docs.add( j ) );
                }
            );
            Object.entries( comparisons ).forEach(
                i => {
                  docs.add( i[0] );
                  Object.keys( i[1] ).forEach( j => docs.add( j ) );
                }
            );
            report.docs = Array.from( docs );
            report.docsNames = ans.names;

            const matrix = {};
            for ( const r of report.docs ) {
              matrix[ r ] = {};
              for ( const c of report.docs ) {
                matrix[ r ][ c ] = "";
              }
            }

            for ( const rid of report.docs ) {
              for ( const cid of report.docs ) {
                let v = null;

                //commons
                if ( rid in commons ) {
                  const r = commons[ rid ];
                  if ( cid in r ) {
                    const cv = r[ cid ];
                    if ( cv !== undefined && cv !== null ) v = cv;
                  }
                }

                //comparisons
                if ( cid in comparisons ) {
                  const c = comparisons[ cid ];
                  if ( rid in c ) {
                    const cv = c[ rid ];
                    if ( cv !== undefined && cv !== null ) v = cv;
                  }
                }

                matrix[ rid ][ cid ] = v;
              }
            }

            report.matrix = matrix;
          }
          else {
            report.status = false;
          }

          this.report = report;
        }
        else throw new Error( "empty answer" );
      }
      catch ( e ) {
        console.error( e );
        this.$root.$emit( "notify", { header: this.$t( "InvalidServerAnswer" ), message: e.message, type: "error" } );
      }

      this.loading = false;

      await this.$nextTick();

      if ( this.$refs.reportResults ) {
        const table = this.$refs.reportResults;
        if ( this.$options.crossHighlighter ) table.removeEventListener( "mouseout", this.$options.crossHighlighter );

        //light diagonal
        for ( let r = 2; r < table.rows.length; r++ ) {
          const row = table.rows[ r ];

          for ( let c = 1; c < row.cells.length; c++ ) {
            const col = row.cells[ c ];

            col.classList.remove( "dg" );
            if ( r - 2 == c - 1 ) col.classList.add( "dg" );
          }
        }

        this.$options.crossHighlighter = e => {
          if ( table ) {

            for ( const c of table.querySelectorAll( ".lr, .lc" ) ) c.classList.remove( "lr", "lc" );

            if ( table.contains( e.relatedTarget ) ) {
              let cell = e.relatedTarget;

              while ( cell ) {
                if ( cell.tagName == "TABLE" ) break;

                if ( cell.tagName == "TD" || cell.tagName == "TH" ) {
                  //line
                  for ( const c of cell.parentNode.cells ) c.classList.add( "lr" );

                  //column
                  const ci = cell.cellIndex;
                  for ( const r of table.rows ) {
                    r.cells[ ci ].classList.add( "lc" );
                  }
                  break;
                }

                cell = cell.parentNode;
              }
            }
          }
        };

        table.addEventListener( "mouseout", this.$options.crossHighlighter );
      }
    },

    tableToExcel( table, filename, worksheetName ) {
      const uri = 'data:application/vnd.ms-excel;base64,';
      const template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>';
      const base64 = s => window.btoa(unescape(encodeURIComponent( s ) ) );
      const format = ( s, c ) => s.replace( /{(\w+)}/g, ( m, p ) => c[ p ] );
      const downloadURI = ( uri, name ) => {
        const link = document.createElement( "a" );
        link.download = name;
        link.href = uri;
        link.click();
        link.remove();
     };
      if ( !table.nodeType ) table = document.getElementById( table );
      const ctx = { worksheet: worksheetName || 'Worksheet', table: table.innerHTML };
      const resuri = uri + base64( format( template, ctx ) );
      downloadURI( resuri, filename );
    }
  }
}
</script>

<style scoped>
.wrapper {
  padding: 1em;
}

.send {
}

h1 {
  font-weight: bold;
  font-size: 1.5em;
  margin-bottom: 0.8em;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.results {
  margin-top: 2em;
}

.results th {
  color: #007BC1;
}

.results th,
.results td {
  padding: 0.2em 0.5em;
  text-align: left;
  vertical-align: top;
}
.results tr > *:first-child {
  padding-left: 0;
}
.results tr > *:last-child {
  padding-right: 0;
}

.results td {
  font-weight: bold;
  color: #000000;
}

.results thead th,
.results thead td {
  font-weight: normal;
  color: #0081CA;
  padding-bottom: 0.25em;
  border: solid #0081CA;
  border-width: 0 0 1px 0;
  text-transform: uppercase;
}
.results thead ~ tbody > tr:first-child td,
.results thead ~ tbody > tr:first-child th {
  padding-top: 0.75em;
}
.results thead th > span,
.results thead td > span {
  font-weight: bold;
  text-transform: none;
}

.ac {
  font-size: 1.2em;
  background-color: #0081CA;
  color: #FFFFFF;
  border: none;
  border-radius: 0.2em;
  padding: 0.2em 1em;
  min-width: 20em;
}
.ac::v-deep input {
  border: none !important;
  background-color: #FFFFFF;
  color: #000000;
}
.ac::v-deep .results {
  background-color: #FFFFFF;
  color: #0081CA;
  border-color: #0081CA;
  max-width: 80vw;
  right: unset;
  min-width: 100%;
  border-radius: 0.2em;
  scrollbar-width: thin;
  box-sizing: border-box;
  box-shadow: 0 3px 3px rgba( 0, 0, 0, 0.5 );
  scrollbar-color: #0081CA #DBF1FF;
}
.ac::v-deep .results > .active,
.ac::v-deep .results .item:hover {
  background-color: #DBF1FF;
  color: #0081CA;
}
.ac::v-deep .results .item {
  white-space: nowrap;
}
.ac::v-deep input {
  text-overflow:ellipsis;
}

.tab {
  padding: 2em 1em;
}

.tab .wholeFileProcessing {
  margin-bottom: 2em;
}
.tab .wholeFileProcessing::v-deep label {
  vertical-align: middle;
}

.report .fieldInput {
  font-size: 1.2em;
  background-color: #0081CA;
  color: #FFFFFF;
  border: none;
  border-radius: 0.2em;
  padding: 0.2em 1em;
  margin: 1em 0;
  width: 20em;
}
.report .fieldInput input {
  border: none !important;
  background-color: #FFFFFF;
  color: #000000;
  border-radius: 0.2em;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: .2em 1em .2em .5em;
  font-size: inherit;
}

.report .scroller {
  width: 100%;
  height: 100vh;
  overflow: auto;
}
.report .results th,
.report .results td {
  white-space: nowrap;
}
.report .results tbody th,
.report .results tbody td {
  border: solid 1px transparent;
}
.report .results tr:nth-child( even ) th,
.report .results tr:nth-child( even ) td {
  background-color: #F0F0F0;
}
.report .results .dg {
  border-color: #0081CA;
}
.report .results .lr {
  background-color: #EAEAEA !important;
}
.report .results .lc {
  background-color: #EAEAEA !important;
}
.report .results .lr.lc {
  background-color: #E0E0E0 !important;
}
/*
.report .results tr:hover td,
.report .results tr:hover th {
  background-color: #0081CA;
  color: #FFFFFF;
}
*/

.infoWrapper {
  display: inline-block;
	position: relative;
  box-sizing: border-box;
  min-width: 100%;
  min-height: 100%;
}
.infoWrapper > .info {
  display: none;
}
.infoWrapper > .info .progress {
  margin-top: 1em;
  width: 100%;
  height: 7px;
  border: solid 1px #0081CA;
  background-color: #FFFFFF;
}
.infoWrapper > .info .progress > .filler {
  height: 100%;
  background-color: #0081CA;
}

.infoWrapper.uploading {
 pointer-events: none;
}

.infoWrapper.uploading  > .info {
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate( -50%, -50% );
  z-index: 1000;
}
</style>
